import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import EfpaInput from "../EfpaInput";
import EfpaBtn from "../EfpaBtn";
import EfpaLink from "../EfpaLink";
import { AuthContext } from "../../contexts/AuthContext";
import { useAxiosClient } from "../../hooks/useAxiosClient";
import getLoginType from "../../utils/loginConfig";
import EfpaForm from "../EfpaForm";
import Message from "../Message";
import { navigate } from "gatsby";
import useCaptchaValidation from "../../hooks/useCaptchaValidation";
import ReCAPTCHA from "react-google-recaptcha";
import useLogin from "../../hooks/useLogin";

const requiredFields = ["username", "password"];

const LoginForm = ({ onLogin, onRecoveryBtn = () => {} }) => {
  const {
    captchaRef,
    captchaError,
    validateCaptcha,
    resetCaptchaError,
    showCaptchaError,
    resetCaptcha,
  } = useCaptchaValidation();
  const { login, setToken, setUserInfo, saveLoginType, getRootToken } =
    useContext(AuthContext);
  const [formData, setFormData] = useState({});
  const [errorData, setErrorData] = useState();
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [, triggerRequest] = useAxiosClient({}, { manual: true });
  const useLoginRequest = useLogin();

  const handleChange = ({ target: { name, value } }) =>
    setFormData((prev) => ({ ...prev, [name]: value }));

  const handleSubmit = async (isValid) => {
    if (!isValid) return setErrorData({ code: "val" });
    try {
      const rootToken = await getRootToken();

      if (!rootToken) return;
      if (!showCaptcha) {
        const res = await triggerRequest({
          url: "/persons/show_captcha/",
          method: "GET",
          params: {
            username: formData.username,
          },
          headers: {
            Authorization: `Bearer ${rootToken}`,
          },
        });
        const { show_captcha } = res.data;
        if (show_captcha) {
          setShowCaptcha(show_captcha);
          showCaptchaError();
          return;
        }
      }
      resetCaptchaError();

      if (showCaptcha && !validateCaptcha()) {
        return;
      }
      const loginType = getLoginType();

      const { data: userData, status: loginStatus } = await useLoginRequest
        .post(loginType.endpoint, formData, {
          headers: {
            Authorization: `Bearer ${rootToken}`,
          },
        })
        .catch(({ response: { status, data } }) => {
          const [msg] = Array.isArray(data.message) ? data.message : [];
          setErrorData({ code: status, message: msg });
          if (status === 401) {
            const { show_captcha } = data;
            setShowCaptcha(show_captcha);
          }
          resetCaptcha();
          return {};
        });

      if (!Object.keys(userData).length || loginStatus !== 200) return;

      const userToken = await triggerRequest({
        url: "/token/",
        method: "POST",
        data: formData,
      }).then(({ data }) => data.access);

      if (!userToken) return;

      setUserInfo(userData);

      setToken(userToken);
      saveLoginType();

      login(true);

      if (onLogin) onLogin(userData, loginType);
      else navigate(loginType.home);
      //   setStatusCode(200);
    } catch (error) {
      //   setStatusCode(error.response.status);
    }
  };

  const renderError = () => {
    let msg = "Los datos de acceso introducidos son incorrectos";
    if (errorData.code === "val") msg = "Por favor, rellene todos los campos";
    if (errorData.code === 400 && errorData.message) msg = errorData.message;
    return (
      <Message type="error" className="mx-2">
        {msg}
      </Message>
    );
  };

  return (
    <div className="Login-card LoginForm">
      <h2 className="efpa-h2 Login-title">Identifíquese</h2>
      {errorData && renderError()}
      <EfpaForm
        basic
        className="Login-cardContent"
        onSubmit={handleSubmit}
        requiredInputs={requiredFields}
      >
        <EfpaInput
          label="Usuario"
          name="username"
          labelBold
          labelPosition="top"
          onChange={handleChange}
        />
        <EfpaInput
          label="Contraseña"
          name="password"
          labelBold
          labelPosition="top"
          className="mt-3"
          type="password"
          onChange={handleChange}
        />
        <EfpaBtn className="mt-3" type="submit">
          Aceptar
        </EfpaBtn>
        <EfpaLink onClick={onRecoveryBtn} mode="button" className="mt-3">
          ¿Has olvidado tu contraseña?
        </EfpaLink>
        {showCaptcha && (
          <ReCAPTCHA
            sitekey={process.env.GATSBY_CAPTCHA_KEY}
            ref={captchaRef}
            size={"compact"}
            className={" mt-2"}
          />
        )}
        {captchaError && (
          <span cl style={{ color: "red" }}>
            Por favor, complete el captcha
          </span>
        )}
      </EfpaForm>
    </div>
  );
};

LoginForm.propTypes = {
  onLogin: PropTypes.func,
  onRecoveryBtn: PropTypes.func,
};

export default LoginForm;
